import React from 'react';
import { Link } from 'react-router-dom';
import HomeSectionHeader from './HomeSectionHeader';
import { genderCollections } from './homePage.data';
import './HomeGenderSection.scss';

const HomeGenderSection = () => (
  <section className="home-section" aria-labelledby="shop-by-gender-title">
    <HomeSectionHeader
      eyebrow="Shop by gender"
      title="Browse tailored collections"
      titleId="shop-by-gender-title"
    />
    <div className="home-gender-grid">
      {genderCollections.map((collection) => (
        <Link
          key={collection.href}
          to={collection.href}
          className="home-gender-tile home-gender-tile--background"
          style={
            {
              '--home-gender-background': `url(${collection.backgroundImage})`,
            } as React.CSSProperties
          }
        >
          <span className="home-gender-tile__label">{collection.label}</span>
          <strong>{collection.title}</strong>
          <span>{collection.description}</span>
        </Link>
      ))}
    </div>
  </section>
);

export default HomeGenderSection;
